// src/components/ListaAlunos.js
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './ListaAluno.css';

function ListaAlunos() {
  const navigate = useNavigate();
  const [alunos, setAlunos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState(null);
  const [selectedAluno, setSelectedAluno] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchAlunos = async () => {
      const { data, error } = await supabase.from('alunos').select('*');
      if (error) {
        console.error('Erro ao buscar alunos:', error);
        setError('Erro ao carregar alunos: ' + error.message);
        return;
      }
      setAlunos(data);
    };
    fetchAlunos();
  }, []);

  const filteredAlunos = alunos.filter(
    (aluno) =>
      aluno.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
      aluno.matricula.includes(searchTerm)
  );

  const verDetalhes = (aluno) => {
    setSelectedAluno(aluno);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedAluno(null);
  };

  return (
    <div className="lista-container">
      <h1>Lista de Alunos</h1>
      {error && <p className="error-message">{error}</p>}

      <input
        type="text"
        placeholder="Pesquisar por nome ou matrícula"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {alunos.length === 0 ? (
        <p>Nenhum aluno cadastrado ainda.</p>
      ) : (
        <ul>
          {filteredAlunos.length > 0 ? (
            filteredAlunos.map((aluno) => (
              <li key={aluno.matricula} className="aluno-lista-item">
                <div className="aluno-item" onClick={() => verDetalhes(aluno)}>
                  {aluno.foto_url && (
                    <img
                      src={aluno.foto_url}
                      alt={aluno.nome}
                      className="aluno-foto"
                    />
                  )}
                  <div className="aluno-info">
                    {aluno.nome} - Matrícula: {aluno.matricula} - Idade: {aluno.idade}
                  </div>
                </div>

                <button
                  className="botao-editar"
                  title="Editar cadastro"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/editar-aluno/${aluno.matricula}`);
                  }}
                >
                  ✏️
                </button>
              </li>
            ))
          ) : (
            <p>Nenhum aluno encontrado.</p>
          )}
        </ul>
      )}

      <button onClick={() => navigate('/home')}>Voltar</button>

      {showModal && selectedAluno && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Detalhes do Aluno</h2>
            <div className="modal-body">
              {selectedAluno.foto_url ? (
                <img
                  src={selectedAluno.foto_url}
                  alt={selectedAluno.nome}
                  className="modal-foto"
                  style={{ maxWidth: '200px', maxHeight: '200px', marginBottom: '10px' }}
                />
              ) : (
                <p>Sem foto</p>
              )}
              <p><strong>Nome:</strong> {selectedAluno.nome}</p>
              <p><strong>Matrícula:</strong> {selectedAluno.matricula}</p>
              <p><strong>Idade:</strong> {selectedAluno.idade}</p>
              <p><strong>Pai:</strong> {selectedAluno.nome_pai || 'Não informado'}</p>
              <p><strong>Mãe:</strong> {selectedAluno.nome_mae || 'Não informado'}</p>
              <p><strong>Escola:</strong> {selectedAluno.escola || 'Não informado'}</p>
              <p><strong>Tipo de Documento:</strong> {selectedAluno.tipo_documento}</p>
            </div>
            <button onClick={closeModal} className="modal-close-button">Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ListaAlunos;
